import { ITrip, IFlightInterline } from "@cai-services";
import { Flight } from "./flight-input.model";

export class Trip implements ITrip {
  id: number;
  endArrivalDate: Date | string;
  startDepartureDate: Date | string;
  flightNo: string;
  flights: Flight[];
  transitTime: number;
  co2: number;
  interline?: IFlightInterline;

  constructor () {}
}
